export enum FileVisibilityLevel {
  LOCATION,
  BUILDING,
}

export const VisibilityDropdownValues = [
  {
    id: FileVisibilityLevel.LOCATION,
    name: 'Location',
  },
  {
    id: FileVisibilityLevel.BUILDING,
    name: 'Building',
  }
]